

<div class="footer flex">
  <div class="flex-auto flex justify-content-center container">
    <a class="action flex-none mt-2" style="background: rgb(30, 44, 231);color: white;" id="get-vex" mat-flat-button>
      <img style="width: 30px;margin-top: 3px;" 
      class="icon-sm ltr:mr-2 rtl:ml-2"
      src="assets/img/towa_logo.png">
      <span>{{logoName}}</span>

    

    </a>
    <div class="font-medium ltr:ml-4 rtl:mr-4 sm:block justify-content-center pt-3" >
      <p>© {{year}} {{companyName}}. {{Rights}}</p>
    </div>
  </div>
</div>





